export default "__VITE_ASSET__094e0ca1__"